import type { TagParentTypeKey } from '~/types/tagParentTypeKey'

export default ['subgenre', 'country'] as TagParentTypeKey[]
